import { Button } from "../../primitives";
import { useState } from "react";
import Modal from "../../portals/Modal";
import CancelSubscription from "../../popup/CancelSubscription";
import DeleteWorkspace from "../../popup/DeleteWorkspace";
import { catchErrorParse } from "../../../ErrorUtility";
import SubscriptionInfo from "../../popup/SubscriptionInfo";
import { useOutletContext } from "react-router-dom";
import { Accordion } from "../../primitives";
import { useTranslation } from "../../../hooks/useTranslation";
import { useDatabase } from "../../../contexts/DatabaseContext";

export default function ActiveSubscription({ subscription, workspace, serviceIcon, loading, post, url, totalCost, workspaceId }) {
    const { mobile, getBalance, getInvoiceData } = useOutletContext();
    const { createSubscriptionActionEvent, createWorkspaceActionEvent } = useDatabase();
    const [states, setStates] = useState({
        isOpen: false,
        option: 0,
    });
    const t = useTranslation();

    async function handleCancelSubscription() {
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/subscriptions/dec`, {
            subscriptionId: subscription.id,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "cancel_sub",
                    diabolical: true,
                }
            }));
        } else {
            getInvoiceData();
            getBalance();
            createSubscriptionActionEvent("cancel_sub", result.latest_invoice.total, workspace?.workspaceType, workspaceId);
        }
        setStates({ isOpen: false, option: 0 });
    }

    async function handleDeleteWorkspace() {
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/subscriptions/dec`, {
            subscriptionId: subscription.id,
            workspaceId: subscription.workspace,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "delete_sub",
                    diabolical: true,
                }
            }));
        } else {
            getInvoiceData();
            getBalance();
            createWorkspaceActionEvent("delete", workspace?.workspaceType, workspaceId);
            createSubscriptionActionEvent("delete_sub", result.latest_invoice.total, workspace?.workspaceType, workspaceId);
        }
        setStates({ isOpen: false, option: 0 });
    }

    return (
        <>
        {!mobile ? (
            <div className='workspace-subscription-grid'>
                <img src={serviceIcon} alt={workspace?.workspaceType} className='workspace-subscription-icon'/>
                <h4 className='workspace-subscription-name'>{workspace?.workspaceName}</h4>
                <Button className='workspace-subscription-button' onClick={() => setStates({isOpen: true, option: 0})}>{totalCost}</Button>
                <Button className='workspace-subscription-button cancel' disabled={loading} loading={loading} onClick={() => setStates({isOpen: true, option: 1})}>{t('Cancel Subscription')}</Button>
                <Button className='workspace-subscription-button delete' disabled={loading} loading={loading} onClick={() => setStates({isOpen: true, option: 2})}>{t('Delete Workspace')}</Button>
            </div>
        ) : (
            <Accordion>
                <Accordion.Item>
                    <Accordion.Header>
                        <div className='workspace-subscription-row'>
                            <img src={serviceIcon} alt={workspace?.workspaceType} className='workspace-subscription-icon'/>
                            <h4 className='workspace-subscription-name'>{workspace?.workspaceName}</h4>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='workspace-subscription-col'>
                            <Button className='workspace-subscription-button' onClick={() => setStates({isOpen: true, option: 0})}>{totalCost}</Button>
                            <Button className='workspace-subscription-button cancel' disabled={loading} loading={loading} onClick={() => setStates({isOpen: true, option: 1})}>{t('Cancel Subscription')}</Button>
                            <Button className='workspace-subscription-button delete' disabled={loading} loading={loading} onClick={() => setStates({isOpen: true, option: 2})}>{t('Delete Workspace')}</Button>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )}
        <Modal open={states.isOpen} onClickOutside={() => setStates({ isOpen: false, option: 0 })} lock={loading}>
            {
                states.option === 0 ? 
                    <SubscriptionInfo subscription={subscription} onClose={() => setStates({ isOpen: false, option: 0 })} totalCost={totalCost}/> : 
                states.option === 1 ? 
                    <CancelSubscription onConfirm={handleCancelSubscription} onCancel={() => setStates({ isOpen: false, option: 0 })}/> : 
                    <DeleteWorkspace onConfirm={handleDeleteWorkspace} onCancel={() => setStates({ isOpen: false, option: 0 })} workspaceName={workspace?.workspaceName || 'workspace'}/>
            }
        </Modal>
        </>
    )
}
